import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphaOnlyInput]',
  standalone: true,
})
export class AlphaOnlyInputDirective {
  private readonly ngControl = inject(NgControl, { optional: true });

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const filteredValue = input.value.replaceAll(/[^a-zA-Z]/g, '');

    if (this.ngControl) {
      this.ngControl.control?.setValue(filteredValue, { emitEvent: false });
    } else {
      input.value = filteredValue;
    }
  }
}
